import http from '../lib/http';
import {prepareRegisterItemsToRequest} from '../lib/util';

export const FETCH_HABITUE_LIST_START = 'FETCH_HABITUE_LIST_START';
export const FETCH_HABITUE_LIST_ERROR = 'FETCH_HABITUE_LIST_ERROR';
export const FETCH_HABITUE_LIST_SUCCESS = 'FETCH_HABITUE_LIST_SUCCESS';

export const DO_CREDIT_START = 'DO_CREDIT_START';
export const DO_CREDIT_ERROR = 'DO_CREDIT_ERROR';
export const DO_CREDIT_SUCCESS = 'DO_CREDIT_SUCCESS';

export const OPEN_CREDIT_LIST_USERS = 'OPEN_CREDIT_LIST_USERS';
export const CLEAN_HABITUE_LIST = 'CLEAN_HABITUE_LIST';

export function cleanHabitueList() {
    return {
        type: CLEAN_HABITUE_LIST
    };
}

export function doCredit(userId, barId, title, items) {
    return {
        type: 'DO_CREDIT',
        payload: {
            promise: postCredit(userId, barId, title, items)
        }
    };
}

export function openCreditListUser(open, tableId = null) {
    return {
        type: OPEN_CREDIT_LIST_USERS,
        payload: {open, tableId}
    };
}

export function fetchHabitueList(limit, page) {
    return {
        type: 'FETCH_HABITUE_LIST',
        payload: {
            promise: getHabitueList(limit, page)
        }
    };
}

async function postCredit(userId, barId, title, items) {
    const res = await http.post(`/app/bills/credit/${userId}/${barId}`, {
        body: {
            title: title,
            items: prepareRegisterItemsToRequest(items)
        }
    });
    if (res.status < 300) return res.json();
    throw res;
}

async function getHabitueList(limit, page) {
    const res = await http.get(`/app/bills/habitue-list/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/creditBill/actions.js